export default __webpack_public_path__ + "static/633-9b10449be6a59bef6dd948651d26d1b7.gif";